export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7047c39562c0c14cc1f0d5d799139c8890474f0fa4&name=pushAdClickData!'